import { Col } from '@zg-rentals/zrs-comet';
import Bone from '../Bone';
import InboxPanelHeaderSkeleton from './components/Header/skeleton';

const Skeleton = (): JSX.Element => {
  return (
    <div>
      <InboxPanelHeaderSkeleton />

      <Col xs={4}>
        <br />
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={12}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={7}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={12}>
        <Bone dark={true} type="line" />
        <br />
      </Col>

      <Col xs={4}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={12}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={7}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
      <Col xs={12}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
    </div>
  );
};

export default Skeleton;
